<!--
  DistributorProfile -- the distributor's COMPANY page: one form, one Save
  (business, time zone, billing contact, billing address, ship-from address).

  WAS A TWO-TAB PAGE until 2026-09-24. The second tab ("Integrations", which
  mounted a Stripe row + SupplierIntegrations.vue) moved out to its own
  Account page, per Jake: "I want to move Integrations out to the Account
  section in the left-nav as their own page, just below the Company Profile
  page." That page is now Suppliers (Stripe Connect lives on Payments only;
  IA unit U1) and this page is titled Company.

  The tab CHROME went with it rather than being left as a single-tab strip.
  A tab bar with one tab is a control that cannot do anything -- it says
  "there is somewhere else to go" and then does not go there. The sections
  below now stack directly, the way the other single-purpose Account pages
  render.
-->
<template>
  <v-container>
    <account-info />
  </v-container>
</template>

<script>
import AccountInfo from "./DistributorAccountInfo.vue";

// The Company page is ONE form with ONE Save (CompanyForm, mounted by
// DistributorAccountInfo). The time zone used to be a second card here
// (LocalePreferences) with its own Save; it is a field of the form now.
export default {
  components: {
    AccountInfo,
  },
};
</script>
